import { FETCH_RECEIPTS, FETCH_RECEIPTS_SUCCESS, FETCH_RECEIPTS_FAILURE, SAVE_RECEIPTS_SUCCESS,
  SAVE_RECEIPTS_FAILURE, DELETE_RECEIPTS_SUCCESS, DELETE_RECEIPTS_FAILURE, RECEIPTS_AJAX_CALL,
  RECEIPTS_CLEAR_AJAX_CALL } from '../actions/Receipts'

const initialState = {
  list: null,
  last: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null
}

export default function receipts (state = initialState, action) {
  switch (action.type) {
    case FETCH_RECEIPTS:
      return {...state, loading: true, error: null, list: null}
    case FETCH_RECEIPTS_SUCCESS:
      return {...state, list: action.payload.list, last: action.payload.last, loading: false, error: null}
    case FETCH_RECEIPTS_FAILURE:
      return {...state, error: action.payload, last: null, loading: false, list: null}
    case SAVE_RECEIPTS_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.list.id) === -1)
          ? state.list.concat(action.payload.list)
          : state.list.map((item) => {
            return (item.id === action.payload.list.id) ? action.payload.list : item
          })).sort((a, b) => {
          return (a.number < b.number) ? 1 : ((b.number < a.number) ? -1 : 0)
        }),
        last: action.payload.last,
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_RECEIPTS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_RECEIPTS_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload.list.id
        }),
        last: action.payload.last,
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_RECEIPTS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case RECEIPTS_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case RECEIPTS_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/receipts.js